module.exports = __webpack_public_path__ + "static/media/logoImg.1bd99973.png";